import { Component } from '@angular/core';

@Component({
  selector: 'app-fix-help',
  templateUrl: './fix-help.component.html',
  styleUrl: './fix-help.component.scss'
})
export class FixHelpComponent {

}
